import React, { useCallback, useContext } from 'react';
import { WorkspaceContext } from 'views/workspace/workspaceContext';
import { WorkspaceActionCreator } from 'hooks/useWorkspaceState';

const identity = x => x;

export const useWidgetParameter = ({ propertyName, cardIndex, widgetConfiguration, valueFunction = identity }) => {
	const { dispatch } = useContext(WorkspaceContext);

	return useCallback(
		(value) => {
			const newValue = valueFunction(value);

			const configuration = JSON.parse(JSON.stringify(widgetConfiguration));
			if (newValue === null || newValue === 'default' || newValue === 'none') {
				delete configuration[propertyName];
			} else {
				configuration[propertyName] = newValue;
			}
			dispatch(WorkspaceActionCreator.configuration(cardIndex, configuration));
		},
		[cardIndex, dispatch, propertyName, widgetConfiguration]
	);
};
